import React, { Component } from "react";
import styled from "styled-components";
import Line from "./Line";
import cat from "./cat.jpeg";

class Aboutme extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lines: [
        {
          id: 1,
          text: "做的事情：鑽研前端技術 aka 寫網頁",
          active: true,
          deletable: false,
        },
        {
          id: 2,
          text: "興趣：烏克麗麗、唱歌、或是兩個同時",
          active: true,
          deletable: false,
        },
        {
          id: 3,
          text: "閒暇時間：看電影、吃拉麵、KTV",
          active: true,
          deletable: false,
        },
        {
          id: 4,
          text: "若喜歡我的作品請幫我按顆 Star 謝謝您",
          active: false,
          deletable: true,
        },
      ],
    };
  }
  onClickLine = ({ id }) => {
    const { lines } = this.state;
    const lineIndex = lines.findIndex((l) => l.id === id);
    const line = lines[lineIndex];
    if (!line.deletable) return;
    this.setState({
      lines: [
        ...lines.slice(0, lineIndex),
        { ...line, active: !line.active },
        ...lines.slice(lineIndex + 1),
      ],
    });
  };
  render() {
    return (
      <div className={this.props.className}>
        <div className="container">
          <div className="title">楊楚玄</div>
          <div className="content">
            <div className="photo">
              <img src={cat} alt="avatar" />
            </div>
            <div className="text">
              {this.state.lines.map((line) => (
                <Line
                  key={line.id}
                  active={line.active}
                  onClick={() => this.onClickLine(line)}
                  color={line.active ? "white" : "gray"}
                >
                  {line.text}
                </Line>
              ))}
              <div className="conclusion">
                請各位多多指教，歡迎逛逛我的
                <a href="https://github.com/ShizukuIchi">GitHub</a>和
                <a href="https://medium.com/@ShizukuIchi">Medium</a>～
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default styled(Aboutme)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
  .container {
    padding: 50px;
    border-radius: 5px;
    width: 80%;
    height: 80%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .title {
    font-size: 2em;
    color: white;
  }
  .content {
    margin-top: 50px;
    display: flex;
    align-items: center;
  }
  .photo {
    margin-right: 30px;
    max-width: 200px;
    height: 100%;
    display: flex;
    align-items: center;

    img {
      border-radius: 50%;
      height: 90%;
      width: 90%;
    }
  }
  .conclusion {
    margin-top: 30px;
    font-size: 1.2em;
    color: white;
    a {
      display: inline-block;
      transition: 0.3s;
      margin: 0 8px;
      color: #03a9f4;
    }
    a:hover {
      color: #4fc3f7;
      transform: scale(1.1);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Aboutme/index.js